import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedoAlt, faMinus, faLanguage, faArrowRightToBracket } from '@fortawesome/free-solid-svg-icons';
import { msalConfig } from '../authConfig.js';
import { PublicClientApplication } from '@azure/msal-browser';

const msalInstance = new PublicClientApplication(msalConfig);

const ChatHeader = ({ onCloseChat, isTyping, selectLanguage, setMessages, hasFirstMessageBeenAdded, loadFirstMessage, isLoading, showChatUI, setSelectedOption }) => {
  const { t } = useTranslation();
  const [language, setLanguage] = useState(localStorage.getItem('language') || 'en');
  const [showLogout, setShowLogout] = useState(process.env.REACT_APP_SHOW_LOGOUT_BTN == "false" ? false : true)

  const reloadPage = () => {
    if (!hasFirstMessageBeenAdded.current) {
      loadFirstMessage(language);
      hasFirstMessageBeenAdded.current = true;
    } else {
      setMessages([]);
      loadFirstMessage(language);
      hasFirstMessageBeenAdded.current = true;
    }
    setSelectedOption("")
  };

  const handleLanguageToggle = () => {
    const newLanguage = language === 'en' ? 'ar' : 'en';
    setLanguage(newLanguage);
    selectLanguage(newLanguage);
    localStorage.setItem('language', newLanguage);
  };

  useEffect(() => {
    initializeMsal()
  }, [])

  const initializeMsal = async () => {
    await msalInstance.initialize();
  };

  const handleLogout = () => {
    msalInstance.logoutRedirect();
  };

  useEffect(() => {
    const storedLanguage = localStorage.getItem('language');
    if (storedLanguage) {
      setLanguage(storedLanguage);
      selectLanguage(storedLanguage);
    }
  }, [selectLanguage]);

  return (
    <div className={`chat-header-out`}>
      <div className='header-actions'>
        <div className='chat-header'>
          <img src="/logo-chatbot.gif" className='logo-home-page' alt="avatar" className="avatar" />
          <div className='flex-row'>
            <div className="hello">{t('Hello!')}</div>
            <div className='i-can-help'>{t('I can help you with HR services.')}</div>
          </div>
        </div>
        <img src={`./lang-icon.svg`} alt="" srcset="" className='language-icon'
          onClick={() => handleLanguageToggle()} />
        <img className='action-reload' onClick={reloadPage} onTouchStart={reloadPage} src="./refresh-icon.svg" />
        {/* <img className='action close-chatbot' onClick={onCloseChat} onTouchStart={onCloseChat} src="./close-icon.svg" /> */}
        {/* {showLogout && <FontAwesomeIcon className='action' icon={faArrowRightToBracket} onClick={handleLogout} onTouchStart={handleLogout} />} */}
      </div>
    </div>
  );
};

export default ChatHeader;
